import type { CSSProperties } from 'vue'
import type { ExtendedBlock } from 'widget-components/integrations/CustomPage/types'
import { getStickyPositionStyle } from 'widget-components/components/Container/container-sticky-position'
import { isNotNil } from 'ramda'
import { useBreakpoints } from 'widget-components/composables/breakpoints'

export const getBlockClasses = (block: ExtendedBlock): string[] => {
    if (block.type === 'CONTAINER') {
        return [
            'h-full',
            block.responsiveVisibility && block.responsiveVisibility !== 'always'
                ? `${block.responsiveVisibility}-visible`
                : undefined,
        ].filter(isNotNil)
    }

    return []
}

export const getBlockStyles = (block: ExtendedBlock): CSSProperties => {
    let isMobile = false

    try {
        const { sm } = useBreakpoints()
        isMobile = !!sm.value
    } catch (error) {
        // eslint-disable-next-line no-console
        console.warn('Breakpoints error: ', error)
    }

    if (block.type === 'CONTAINER') {
        return {
            ...(isMobile && (block.mobileFlexMultiplier !== undefined || block.flexMultiplier!== undefined) ? ({ flex: block.mobileFlexMultiplier || block.flexMultiplier }) : ({})),
            ...(!isMobile && block.flexMultiplier !== undefined ? ({ flex: block.flexMultiplier }) : ({})),
            ...getStickyPositionStyle(block.stickyPosition),
        }
    }

    return {}
}
